import { ReactComponent as dashboard } from "./dashboard.svg";
import { ReactComponent as caregiverList } from "./caregiverList.svg";
import { ReactComponent as patientList } from "./patientList.svg";
import { ReactComponent as appointments } from "./appointments.svg";
import { ReactComponent as taskList } from "./taskList.svg";
import { ReactComponent as invoice } from "./invoice.svg";
import { ReactComponent as settings } from "./settings.svg";
import { ReactComponent as evvLogoFull } from "./evv-logo-full.svg";
import { ReactComponent as evvLogoNew } from "./evv-logo-new.svg";
import { ReactComponent as evvLogoLight } from "./evv_logo_light.svg";
import { ReactComponent as evvLogoDark } from "./evv_logo_dark.svg";
import { ReactComponent as menuBtn } from "./menuBtn.svg";
import { ReactComponent as finance } from "./finance.svg";
import { ReactComponent as fileClock } from "./file_clock.svg";
import { ReactComponent as filePdf } from "./file_pdf.svg";
import { ReactComponent as file } from "./file.svg";
import { ReactComponent as yahoo } from "./yahoo.svg";
import { ReactComponent as gmail } from "./gmail.svg";
import { ReactComponent as outlook } from "./outlook.svg";
import { ReactComponent as aol } from "./aol.svg";
import { ReactComponent as visa } from "./visa.svg";
import { ReactComponent as unionpay } from "./unionpay.svg";
import { ReactComponent as amex } from "./amex.svg";
import { ReactComponent as mastercard } from "./mastercard.svg";
import { ReactComponent as cartesBancaires } from "./cartes_bancaires.svg";
import { ReactComponent as dinersClub } from "./diners_club.svg";
import { ReactComponent as jcb } from "./jcb.svg";
import { ReactComponent as discover } from "./discover.svg";
import { ReactComponent as pipe } from "./pipe.svg";

export const SvgDashboard = dashboard;
export const SvgCaregiverList = caregiverList;
export const SvgPatientList = patientList;
export const SvgAppointments = appointments;
export const SvgTaskList = taskList;
export const SvgInvoice = invoice;
export const SvgSettings = settings;
export const SvgEvvLogoFull = evvLogoFull;
export const SvgEvvLogoNew = evvLogoNew;
export const SvgEvvLogoLight = evvLogoLight;
export const SvgEvvLogoDark = evvLogoDark;
export const SvgMenuButton = menuBtn;
export const SvgFinance = finance;
export const SvgFile = file;
export const SvgFileClock = fileClock;
export const SvgFilePdf = filePdf;
export const SvgGmail = gmail;
export const SvgYahoo = yahoo;
export const SvgOutlook = outlook;
export const SvgAol = aol;
export const SvgVisa = visa;
export const SvgAmericanExpress = amex;
export const SvgUnionPay = unionpay;
export const SvgMastercard = mastercard;
export const SvgCartesBancaires = cartesBancaires;
export const SvgDinersClub = dinersClub;
export const SvgJcb = jcb;
export const SvgDiscover = discover;
export const SvgPipe = pipe;
